// 低优先级js代码最后执行

// watermark
require('./watermark.js')
// 水印内容
let username = document.getElementById('usernameTop')
username = username ? username.innerText : ''
const text = window.watermarkText || username
// 有登录，则打水印
// firefox 89以下的某个版本(Tor内置浏览器)，水印会导致网站不可用，故屏蔽之
let firefoxMainVersion = (window.navigator && window.navigator.userAgent) ? parseInt((window.navigator.userAgent.toLowerCase().match(/firefox\/[\d]+/gi) + '').replace(/[^0-9.]/ig, ""), 10) : 0
if (text && (isNaN(firefoxMainVersion) || firefoxMainVersion >= 89)) {
  // 明水印
  window.watermark.load({
    watermark_txt: text,
    watermark_alpha: 0.03,
    watermark_x_space: 10,
    watermark_width: 170
  })
  // 暗水印
  const canvas = document.createElement('canvas')
  canvas.width = 320
  canvas.height = 180
  const ctx = canvas.getContext('2d')
  ctx.rotate(-20*Math.PI/180)
  ctx.font = "40px Microsoft Arial"
  ctx.textAlign = "center"
  ctx.textBaseline = "middle"
  // 渐变
  var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0)
  gradient.addColorStop("0","rgba(0,0,0,0.005)")
  gradient.addColorStop("0.5","rgba(0,0,0,0.005)")
  gradient.addColorStop("1.0","rgba(0,0,0,0.005)")
  // gradient.addColorStop("0","rgba(0,0,0,0.5)")
  // gradient.addColorStop("0.5","rgba(0,0,0,0.5)")
  // gradient.addColorStop("1.0","rgba(0,0,0,0.5)")
  ctx.fillStyle = gradient
  ctx.fillText(text, 105, 150)
  // ctx.strokeText(text, 104, 130)
  const div = document.createElement('div')
  div.style.position = 'absolute'
  div.style.top = '0'
  div.style.width = '100%'
  div.style.pointerEvents = 'none'
  div.style.zIndex = '9999'
  div.style.height ='100%'
  div.style.background = 'url(' + canvas.toDataURL() + ')'
  document.body.appendChild(div)
}
